var map = {
	"./activity.de.json": 8111,
	"./activity.en.json": 4136,
	"./activity.es.json": 9178,
	"./activity.pl.json": 1478,
	"./activity.sv.json": 2001,
	"./challenge.de.json": 6439,
	"./challenge.en.json": 8069,
	"./challenge.es.json": 9324,
	"./challenge.pl.json": 384,
	"./challenge.sv.json": 3941,
	"./cookie.de.json": 7977,
	"./cookie.en.json": 7059,
	"./cookie.es.json": 5582,
	"./cookie.pl.json": 7397,
	"./cookie.sv.json": 503,
	"./discipline.de.json": 9674,
	"./discipline.en.json": 9295,
	"./discipline.es.json": 6633,
	"./discipline.pl.json": 1819,
	"./discipline.sv.json": 137,
	"./navBar.de.json": 1117,
	"./navBar.en.json": 4579,
	"./navBar.es.json": 4965,
	"./navBar.pl.json": 6843,
	"./navBar.sv.json": 6685,
	"./page.de.json": 3902,
	"./page.en.json": 3839,
	"./page.es.json": 6706,
	"./page.pl.json": 2735,
	"./page.sv.json": 2859,
	"./profile.de.json": 3294,
	"./profile.en.json": 5844,
	"./profile.es.json": 6108,
	"./profile.pl.json": 4481,
	"./profile.sv.json": 6003,
	"./time.de.json": 5162,
	"./time.en.json": 4749,
	"./time.es.json": 6782,
	"./time.pl.json": 1565,
	"./time.sv.json": 4083
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9259;